import PropTypes from 'prop-types'
import React from 'react'
import { AddPageContent, ErrorNotification, PageHeader } from 'SRC/ui'
import { Preloader } from 'SRC/ui/Preloader'
import { connect } from 'react-redux'
import { getAdForPromo, getActivatePromoError, getProfileLoading } from '../../../selectors'
import { PromoPeriods } from '../../PromoPeriods'
import { setActivatePromoError, setProfileLoading } from '../../../actions'
import { setAppInternalTransitionFunc } from 'SRC/modules/common/actions'
import Router from 'next/router'

const desc = `Pošaljite zahtjev za PROMO OGLAS u dužini od 5 ili 10 dana na NASLOVNOJ STRANICI i stranici KATEGORIJE oglasa. Posle poslatog zahtjeva dobićete informacije kako da izvršite uplatu,
kada vaša uplata bude vidljiva na našem računu, oglas će biti postavljen kao PLAĆEN. Za pomoć oko PROMO oglasa pozovite +382 67 733 941`

export class ActivatePromo extends React.PureComponent {
  constructor (props) {
    super(props)

    if (Router.router) {
      Router.router.events.on('routeChangeStart', this.onRouteChangeStartHandler)
      Router.router.events.on('routeChangeComplete', this.onRouteChangeCompleteHandler)
    }
  }

  componentDidMount () {
    this.props.setAppInternalTransitionFunc(this.isInternalTransition)
  }

  componentWillUnmount () {
    this.props.setAppInternalTransitionFunc(null)
  }

  onRouteChangeStartHandler = url => {
    if (this.isInternalTransition(url)) {
      this.showSpinner()
    }
  }

  onRouteChangeCompleteHandler = () => {
    this.hideSpinner()
  }

  isInternalTransition = url => /^\/profil.*/.test(url)

  showSpinner = () => {
    this.props.setProfileLoading(true)
  }

  hideSpinner = () => {
    this.props.setProfileLoading(false)
  }
  hideError = () => {
    this.props.setActivatePromoError('')
  }

  render () {
    const {ad, error, isLoading} = this.props
    return [
      <PageHeader key='header'>Aktiviraj promo</PageHeader>,
      <AddPageContent
        title={ad && `ZAHTJEV ZA PROMO: ${ad.titleCompiled || ''}`}
        description={desc}
        descriptionClass='heading-lead'
        key='content'
      >
        <PromoPeriods />
        <ErrorNotification error={error} hideNotification={this.hideError} />
        {isLoading ? <Preloader /> : null}
      </AddPageContent>
    ]
  }
}

const mapStateToProps = state => ({
  ad: getAdForPromo(state),
  error: getActivatePromoError(state),
  isLoading: getProfileLoading(state)
})

ActivatePromo.propTypes = {
  ad: PropTypes.any,
  error: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  setActivatePromoError: PropTypes.func.isRequired,
  setProfileLoading: PropTypes.func.isRequired,
  setAppInternalTransitionFunc: PropTypes.func.isRequired
}

ActivatePromo.defaultProps = {
  isLoading: false
}

export default connect(
  mapStateToProps,
  {
    setActivatePromoError,
    setProfileLoading,
    setAppInternalTransitionFunc
  }
)(ActivatePromo)
